import type { PersonAttribute as PersonAttributeModel } from '@/adapters/catalogv1.g';

export function extractPersonAttribute(model: PersonAttributeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    personRef: model.person_ref ?? '',
    attributeRef: model.attribute_ref ?? '',
    value: model.value ?? '',
    type: model.type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPersonAttribute = ReturnType<typeof extractPersonAttribute>;
